import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { fetch } from '@ngrx/router-store/data-persistence';
import * as InventoryActions from './inventory.actions';
import { InventoryService } from './inventory.service';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs';
import { CartActions } from '@us/web/cart/data-access';
import { OrdersActions } from '@us/web/orders/data-access';
import { AppInit } from '@us/web/shared/app';
import { getErrorMessage, isFnBApp } from '@us/web/shared/utils';
import { selectShopId, selectTurnOnTheStoreChainLinkFeature } from '@us/web/shop/data-access';
import { selectSelectedShopId } from '@us/web/shops/data-access';
import { tuiIsPresent } from '@taiga-ui/cdk';
import { Store } from '@ngrx/store';
import { ENVIRONMENT } from '@us/app-config';

@Injectable()
export class InventoryEffects {
    private readonly actions$ = inject(Actions);
    private readonly inventoryService = inject(InventoryService);
    private readonly store = inject(Store);
    private readonly env = inject(ENVIRONMENT);
    readonly shopIdParams$ = (isFnBApp(this.env)
        ? this.store.select(selectShopId)
        : this.store
              .select(selectTurnOnTheStoreChainLinkFeature)
              .pipe(
                  switchMap(chain =>
                      chain ? this.store.select(selectSelectedShopId) : this.store.select(selectShopId)
                  )
              )
    ).pipe(
        filter(tuiIsPresent),
        filter(e => !!e),
        distinctUntilChanged()
    );

    init$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(
                AppInit,
                InventoryActions.init,
                CartActions.submitCartSuccess,
                OrdersActions.completeOrder,
                OrdersActions.loadOrder
            ),
            fetch({
                run: () => {
                    return this.shopIdParams$.pipe(
                        switchMap(shopId => this.inventoryService.getData({ shop_id: shopId })),
                        map(items => InventoryActions.loadInventorySuccess({ items: items }))
                    );
                },
                onError: (action, error) => {
                    console.error('Error', error);
                    return InventoryActions.loadInventoryFailure({ error: getErrorMessage(error) });
                }
            })
        );
    });
}
